// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b804552","455":"973560a1","977":"092cb1f1"}[chunkId] + ".chunk.js";
};